import React from 'react'
import SupplierContactButton from '../form/SupplierContactButton'

const SupplierContactsOptions = ({ supplierId }) => {
  return (
    <div>
        <SupplierContactButton 
            supplierId={supplierId}
        />
    </div>
  )
}

export default SupplierContactsOptions